.section {
  position: relative;
  z-index: 1;
  padding: 7rem 6vw;
}

.header {
  max-width: 680px;
  margin: 0 auto 3.5rem;
  text-align: center;
}

.eyebrow {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  color: var(--teal);
  letter-spacing: 0.22em;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.heading {
  font-family: var(--font-display);
  font-size: clamp(1.9rem, 4vw, 3rem);
  font-weight: 800;
  color: var(--white);
  line-height: 1.1;
  letter-spacing: -0.02em;
}

.accent { color: var(--teal); }

/* ── Product card ── */
.productCard {
  position: relative;
  max-width: 1100px;
  margin: 0 auto;
  background: linear-gradient(135deg, rgba(14,22,14,0.9) 0%, rgba(10,26,18,0.9) 100%);
  border: 1px solid rgba(57, 220, 120, 0.18);
  border-radius: 22px;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 420px;
  min-height: 520px;
}

.cardGlow {
  position: absolute;
  top: -80px;
  left: 40%;
  width: 380px;
  height: 380px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(57,220,120,0.1) 0%, transparent 70%);
  pointer-events: none;
}

/* ── Left: info ── */
.productInfo {
  padding: 3.5rem 3rem;
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
}

.productMeta {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.productLogo {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background: linear-gradient(135deg, #2ecc71 0%, #1a8a4a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.logoIcon {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.appLogo {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-family: var(--font-display);
  font-size: 0.72rem;
  font-weight: 800;
  color: #39dc78;
}

.appLogoIcon {
  width: 1rem;
  height: 1rem;
  color: #39dc78;
}

.productName {
  font-family: var(--font-display);
  font-size: 2.4rem;
  font-weight: 900;
  color: #39dc78;
  letter-spacing: -0.03em;
  line-height: 1;
}

.productByline {
  font-family: var(--font-mono);
  font-size: 0.65rem;
  color: rgba(255,255,255,0.3);
  letter-spacing: 0.15em;
  text-transform: uppercase;
  margin-top: 2px;
}

.productDesc {
  font-size: 0.975rem;
  color: var(--mist);
  line-height: 1.82;
}

.featureList {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.featureItem {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  font-size: 0.875rem;
  color: rgba(255,255,255,0.7);
}

.featureDot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #39dc78;
  flex-shrink: 0;
}

.techPill {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(57,220,120,0.08);
  border: 1px solid rgba(57,220,120,0.2);
  padding: 0.4rem 0.85rem;
  border-radius: 20px;
  font-family: var(--font-mono);
  font-size: 0.68rem;
  color: #39dc78;
  width: fit-content;
}

/* ── Store buttons ── */
.storeButtons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.storeBtn {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.65rem 1.15rem;
  border-radius: 8px;
  text-decoration: none;
  transition: transform 0.15s, filter 0.2s;
  min-width: 140px;
}

.storeBtn:hover {
  transform: translateY(-2px);
  filter: brightness(1.1);
}

.storeBtnPrimary {
  background: #39dc78;
  color: #051a0d;
}

.storeBtnDark {
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  color: var(--white);
}

.storeBtnSub {
  display: block;
  font-size: 0.6rem;
  opacity: 0.7;
  letter-spacing: 0.06em;
  line-height: 1;
  font-family: var(--font-body);
}

.storeBtnMain {
  display: block;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.3;
  font-family: var(--font-display);
}

/* ── Right: phone ── */
.productVisual {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.5rem;
  position: relative;
}

/* ── Phone mockup ── */
.phoneMockup {
  position: relative;
  width: 220px;
}

.phoneFrame {
  width: 220px;
  height: 440px;
  border-radius: 36px;
  border: 2px solid rgba(57,220,120,0.3);
  background: rgba(57,220,120,0.03);
  overflow: hidden;
  position: relative;
  box-shadow: 0 0 60px rgba(57,220,120,0.08), inset 0 0 0 1px rgba(255,255,255,0.04);
}

.phoneNotch {
  width: 220px;
  height: 440px;
  border-radius: 36px;
  border: 2px solid rgba(57,220,120,0.3);
  background: #0c1a10;
  box-shadow: 0 0 60px rgba(57,220,120,0.08), inset 0 0 0 1px rgba(255,255,255,0.04);
  overflow: hidden;
  position: relative;
}

.phoneNotch::before {
  content: "";
  position: absolute;
  top: 14px;
  left: 50%;
  transform: translateX(-50%);
  width: 72px;
  height: 10px;
  background: rgba(57,220,120,0.15);
  border-radius: 8px;
  z-index: 2;
}

.phoneScreen {
  position: absolute;
  inset: 0;
  padding: 36px 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.statusBar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: var(--font-mono);
  font-size: 0.55rem;
  color: rgba(255,255,255,0.4);
  padding: 0 2px;
}

.statusIcons {
  display: flex;
  gap: 4px;
  align-items: center;
}

.appHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 8px;
  background: rgba(57,220,120,0.08);
  border-radius: 8px;
  border: 1px solid rgba(57,220,120,0.15);
}

.appLogo {
  font-family: var(--font-display);
  font-size: 0.72rem;
  font-weight: 800;
  color: #39dc78;
}

.appBadge {
  font-family: var(--font-mono);
  font-size: 0.45rem;
  letter-spacing: 0.1em;
  color: #39dc78;
  background: rgba(57,220,120,0.15);
  padding: 2px 5px;
  border-radius: 4px;
}

.screenSection {
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 10px;
  padding: 8px 10px;
}

.screenLabel {
  font-family: var(--font-mono);
  font-size: 0.52rem;
  color: rgba(255,255,255,0.35);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.playerList {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.playerRow {
  display: flex;
  align-items: center;
  gap: 6px;
}

.playerAvatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.55rem;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
}

.playerName {
  font-size: 0.6rem;
  color: rgba(255,255,255,0.7);
  flex: 1;
}

.playerPos {
  font-family: var(--font-mono);
  font-size: 0.5rem;
  color: rgba(57,220,120,0.6);
  letter-spacing: 0.05em;
}

.voteSection {
  background: rgba(57,220,120,0.06);
  border: 1px solid rgba(57,220,120,0.15);
  border-radius: 10px;
  padding: 8px 10px;
}

.voteSectionLabel {
  font-size: 0.6rem;
  color: #39dc78;
  font-weight: 600;
  margin-bottom: 6px;
}

.voteBar {
  height: 5px;
  background: rgba(57,220,120,0.15);
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 4px;
}

.voteBarFill {
  height: 100%;
  width: 68%;
  background: linear-gradient(90deg, #39dc78, #63d2be);
  border-radius: 3px;
}

.voteCount {
  font-family: var(--font-mono);
  font-size: 0.5rem;
  color: rgba(255,255,255,0.3);
}

/* Floating badges */
.floatingBadge {
  position: absolute;
  background: rgba(14,26,14,0.92);
  border: 1px solid rgba(57,220,120,0.25);
  border-radius: 10px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
}

.badge1 {
  top: 1rem;
  right: -0.5rem;
  animation: float 3.2s ease-in-out infinite;
}

.badge2 {
  bottom: 3.5rem;
  left: -0.5rem;
  animation: floatB 4s 0.8s ease-in-out infinite;
}

.badgeEmoji { font-size: 1rem; }

.badgeText {
  font-family: var(--font-mono);
  font-size: 0.58rem;
  color: #39dc78;
  font-weight: 600;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

/* ── Coming soon ── */
.comingSoon {
  max-width: 1100px;
  margin: 1.5rem auto 0;
  padding: 1.4rem;
  border: 1px dashed rgba(255,255,255,0.08);
  border-radius: 12px;
  text-align: center;
}

.comingSoonText {
  font-size: 0.85rem;
  color: rgba(255,255,255,0.25);
  letter-spacing: 0.05em;
}

.comingSoonMono {
  font-family: var(--font-mono);
  color: var(--teal);
  opacity: 0.5;
}

/* ── Responsive ── */
@media (max-width: 900px) {
  .productCard {
    grid-template-columns: 1fr;
  }
  .productVisual {
    display: none;
  }
  .productInfo {
    padding: 2.5rem 2rem;
  }
}

@media (max-width: 560px) {
  .section { padding: 5rem 5vw; }
  .storeButtons { flex-direction: column; }
  .storeBtn { justify-content: center; }
}
